module.exports = {
  hero: {
    nav: [ 
      {
        text: 'Projects',
        link: 'work-section',
        icon: 'code-fork'
      },
      {
        text: 'Contact',
        link: 'contact-section',
        icon: 'envelope-o'
      }
    ],
    heading: 'ECO- LOGIC SYSTEMS, LLC ',
    revealText: 'ENVIRONMENT & INNOVATION - CONSULTANCY & ADVOCACY',
    buttonText: 'Contact Us Now'
  },

  pitch: {
    headerTitle: 'SERVICES RENDERED: ',
    headerText: 'Our passion is helping to realize innovative solutions',
    pitchItems: [
      {
        title: 'INNOVATIVE SOLUTIONS',
        icon: 'cogs',
        text: `We’ll find a way. 
        If you have a new business idea or a promising project that is environmentally safe and economically viable, we’ll make it happen.`,
      },
      {
        title: 'GREEN SOLUTIONS',
        icon: 'tree',
        text: `Sustainability design.
        Be it new office towers, existing residential buildings, renewable energy projects, or Waste to Energy
        facilities, we will advise and guide.`,
      },
      {
        title: 'INVESTMENT SOLUTIONS',
        icon: 'pie-chart',
        text: `We will raise it or protect it.
        Croatia today has many exciting investment opportunities, and more are on the horizon. But guidance
        and care are required, and that's what we provide.`,
      }
    ]
  },

  work: {
    headerTitle: 'BIO',
    headerText: `
      Mark Gero has been active in the environmental industry in Croatia since 1999 as president of Eco-Logic Systems, llc and presently works as a renewable energy, green building, and innovative business consultant. He served four years on the Board of Governors of the American Chamber of Commerce in Croatia, culminating as President, and chaired the Chamber’s Environmental Committee for nine years from its inception in 2002 until May of 2011. He was a driving force initiating, and presently sits on the Steering Committee of the first Environmental Management post graduate educational degree program in Croatia which is now a part of the University of Zagreb. He is chairman of CO2cut.com, which aims to reduce one's carbon footprint when shopping online, and a partner in Nuda Veritas d.o.o. an international licensing and financial advisory service. He is a LEED© Accredited Professional with a specialty in Building Design and Construction; co-founder and first Board of Directors president of Croatia Green Building Council, serving five years in total on their Board. He works with GEA@275™ and the scientist Dr. Staša Puškarić towards the ultimate removal of massive quantities of atmospheric carbon dioxide. He is married and the proud father of three daughters, Chiara Nicole, Magdalena May and Stella Rose.`,
    workItems: [
      { 
        title: 'GEA@275™',
        link: `https://gea275.wordpress.com/`,
        image: 'gea',
        staticImage: '/static/media/work-ss.349d4f52.png',
        tags: [
          'Carbon Capture', 'Technology', 'Science'
        ],
        description: `GEA@275™ Oceanic Carbon Capture Protocol is a groundbreaking carbon dioxide removal and long
        term storage technology. 16 years in the making, a science discovery by Professor Staša Puškarić from
        Dubrovnik, Croatia, GEA is now ready for final stage funding to bring this game changing technology to
        market. Details upon request.`
      },
      { 
        title: 'Banko Vane Machine',
        link: 'https://www.banko.hr/',
        image: 'banko',
        staticImage: '/static/media/work-ts.0f9a2176.png',
        tags: [
          'Licensing', 'Patent', 'Technology'
        ],
        description: `Banko Vane Machine. In partnership with Nuda Veritas, we are presenting for international licensing,
        the proprietary innovative vane machine from Banko d.o.o. of Split Croatia. Initial funidng for this
        innovation was provided by BICRO, the Business Innovation Center of Croatia. Details upon request.`
      },
      { 
        title: 'CO2cut',
        link: 'https://co2cut.com/',
        image: 'co2cut',
        staticImage: '/static/media/work-mys.10cb2a8d.png',
        tags: [
          'Technology', 'Mobile web App', 'Investment'
        ],
        description: `CO2cut. Shop Until Your Carbon Drops! Eco- Logic Systems is a partner and promoter of CO2cut.com,
        an internet based portal tool designed to offer its users the opportunity to reduce global carbon dioxide
        atmospheric emissions at no cost each time they shop online. Details upon request.`
      }
    ]
  },

  contact: {
    headerTitle: 'Contact',
    headerText: `
    Eco- Logic Systems
    Kozarceva 29
    10000 Zagreb, Croatia
    +385 98 130 6905
    markgero@eco-logicsystems.com
    LinkedIn: <a href="https://www.linkedin.com/in/markgero" target="_blank">www.linkedin.com/in/markgero</a>
    Twitter: <a href="https://twitter.com/mark_gero?lang=en" target="_blank">@mark_gero</a>
    Skype: firstvice`,
    buttonText: 'Contact Us'
  }
}


// WEBPACK FOOTER //
// ./src/data.js